import React from 'react';

export enum postGeneratorSteps {
  manageBeers = 'MANAGE_BEERS',
  postType = 'SELECT_POST_TYPE',
  postTemplate = 'SELECT_POST_TEMPLATE',
}

export interface IField {
  id: string;
  style: React.CSSProperties;
  value?: string;
}

export enum postThumbnailFitTypes {
  auto = 'AUTO',
  contain = 'CONTAIN',
  cover = 'COVER',
}
